import { usePageProps } from "../Homepage/Homepage.hooks";
import { useEffect, useState } from "react";
import { request } from "graphql-request";
import { baseUrl } from "services/shared/Environment";
import { tagsQuery } from "./Footer.constants";

export function useCategories() {
  const { categories } = usePageProps();
  return { categories };
}

export function useTags() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request(`${baseUrl()}/api/graphql`, tagsQuery);
      setTags(result?.tags ?? []);
      setLoading(false);
    };
    fetchData();
  }, []);

  return { tags, loading };
}
